import { UpfrontPaymentSummary } from '@dgx-pr-spa/shared/util';
import { createReducer, on } from '@ngrx/store';
import * as fromUpfrontPayment from '../actions/upfront.payment.action';
import { StateSlice } from '@core/helpers/state-slice';

export type UpfrontPaymentState = StateSlice<UpfrontPaymentSummary>;

export const initialState: UpfrontPaymentState = {
  data: {} as UpfrontPaymentSummary,
  loaded: false,
  loading: false,
  error: null,
};

const upfrontPaymentReducer = createReducer(
  initialState,
  on(fromUpfrontPayment.loadUpfrontPayment, () => ({
    ...initialState,
    loading: true,
  })),
  on(fromUpfrontPayment.loadUpfrontPaymentSuccess, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loading: false,
      loaded: true,
    };
  }),
  on(fromUpfrontPayment.loadUpfrontPaymentFail, (_, { payload }) => {
    return {
      ...initialState,
      error: payload,
    };
  }),
  on(fromUpfrontPayment.resetUpfrontPayment, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: UpfrontPaymentState | undefined,
  action: fromUpfrontPayment.UpfrontPaymentActions
) {
  return upfrontPaymentReducer(state, action);
}
